import React from 'react';
import { Zap, ShieldCheck, Clock, CheckCircle } from 'lucide-react';

export const VerifiedSellerBadge: React.FC<{ size?: 'sm' | 'md' }> = ({ size = 'sm' }) => (
  <span className={`inline-flex items-center gap-1 rounded-full font-bold bg-blue-500/10 text-brand-blue dark:text-brand-accent border border-brand-blue/30 ${
    size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
  }`}>
    <CheckCircle className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
    <span>Verified Seller</span>
  </span>
);

export const InstantDeliveryBadge: React.FC = () => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-500/15 text-amber-600 dark:text-amber-400 border border-amber-500/30">
    <Zap className="w-3 h-3" />
    <span>Instant Key</span>
  </span>
);

export const WarrantyBadge: React.FC<{ hours: number }> = ({ hours }) => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30">
    <ShieldCheck className="w-3 h-3" />
    <span>{hours}h Warranty</span>
  </span>
);

export const DeliveryTimeBadge: React.FC<{ minutes: number }> = ({ minutes }) => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-slate-500/10 text-slate-600 dark:text-slate-400">
    <Clock className="w-3 h-3" />
    <span>~{minutes}m Delivery</span>
  </span>
);
